import { theme } from '@/theme';

// Constants for individual steps of Intake Form
export {
    INITIAL_DETAILS,
    SELLER_INFORMATION,
    MAILING_INFO,
    PROPERTY_DETAILS,
    CURRENT_ADDRESS,
    PURCHASER_INFORMATION,
    BORROWER_INFORMATION,
    LENDER_INFORMATION,
} from '@common/constants/intakeSteps';
export const CONTACT_DETAILS = 'userContactDetails';

export const fileNameMap = {
    firstId: 'ID',
    secondId: 'ID',
    purchaseAndSaleAgreement: 'Purchase and sale agreement',
    mortgageStatement: 'Mortgage statement',
    mortgageAgreement: 'Mortgage agreement',
    taxBill: 'Tax bill',
    recentTaxBill: 'Tax bill',
    voidCheque: 'Void Cheque',
    mostRecentTaxBill: 'Tax Bill',
    mostRecentMortgageStatement: 'Mortgage statement, Secured Line of Credit, Home Equity Line',
    anySurveyInYourPossession: 'Survey In Possession',
    mortgageWithdrawals: 'Mortgage Withdrawals',
    homeOrFireInsurancePolicy: 'Home or Fire Insurance Policy',
    realPropertyReport: 'Property Report',
    voidChequeOrDirectDepositStatement: 'Void Cheque',
    voidChequeOrDirectDepositStatementForMortgage: 'Void Cheque',
    validPermanentResidentCard: 'Provide valid Permanent Resident Card',
    vacantUnitTaxDeclaration:
        'For city of Ottawa and Toronto, please provide vacant unit tax declaration',
    statusCertificate: 'Status Certificate',
    correspondencePertainingToPurchase: 'Other Correspondence',
    landSurveyOfProperty: 'Land Survey,',
    homeWarrantyOrTarion: 'New Home Warranty',
    needToBeDischargeOrPaidOut: 'Mortgage or Line of credit or Credit card statements',
    transferOrDeedOfLand: 'Transfer or Deed of land',
    chargeOrMortgageOfLand: 'Charge or Mortgage of land',
    transactionForCorporation: 'Article of incorporation',
};

export const publicRoutes = [
    '/i/',
    '/q/',
    '/quote/view',
    '/intake/view',
    '/lawyerapproval',
    '/clientapproval',
    '/extension-privacy-policy',
];

export const uidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const dateStringRegex =
    /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \([A-Za-z ]+\)$/;

export const dateRegex =
    /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}\s(0?[1-9]|1[0-2]):[0-5]\d:[0-5]\d\s(AM|PM)$/;

export const VALID_CURRENCY_INPUT = /^(?:$|(?:0|[1-9]\d*)(?:\.\d{0,2})?)$/;

export const DEFAULT_INTAKE_FORM_DESCRIPTION =
    'Please complete the intake form below with as much accuracy as possible.';

export const DEFAULT_INTAKE_TEMPLATE_FOOTER =
    'Thank you for submitting the intake form. Rest assured, we are working on your file right away.';

export const ordinalNumbers = Array.from({ length: 10 }, (_, i) => {
    const n = i + 1;
    const suffix = n === 1 ? 'st' : n === 2 ? 'nd' : n === 3 ? 'rd' : 'th';
    return `${n}${suffix}`;
});

export const STATUS_OPTIONS = [
    {
        label: 'Quote requested',
        name: 'QuoteRequested',
        color: theme.palette.warning.main,
        backgroundColor: theme.palette.warning.W_50,
    },
    {
        label: 'Quote sent',
        name: 'QuoteSent',
        color: theme.palette.neutral.N_500,
        backgroundColor: theme.palette.neutral.N_100,
    },
    {
        label: 'Intake sent',
        name: 'IntakeSent',
        color: theme.palette.neutral.N_500,
        backgroundColor: theme.palette.neutral.N_100,
    },
    {
        label: 'Intake completed',
        name: 'IntakeCompleted',
        color: '#389224',
        backgroundColor: theme.palette.success.S_50,
    },
    {
        label: 'Cancelled',
        name: 'Cancelled',
        color: theme.palette.error.E_750,
        backgroundColor: theme.palette.error.E_50,
    },
];

export const THIN_SCROLLBAR_STYLING = {
    scrollbarWidth: 'thin', // For Firefox
    scrollbarColor: `${theme.palette.neutral.N_300} ${theme.palette.neutral.white}`, // For Firefox
    '&::-webkit-scrollbar': {
        width: '8px', // Scrollbar width
        height: '8px', // Scrollbar height for horizontal scroll
    },
    '&::-webkit-scrollbar-track': {
        background: theme.palette.neutral.white, // Track color
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.neutral.N_300, // Thumb color
        borderRadius: '4px', // Thumb border radius
        border: `2px solid ${theme.palette.neutral.white}`, // Creates padding effect in the track
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.neutral.N_300, // Thumb color on hover
    },
};
